import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getUserActivityByUid } from './firebase';
import { STATUS_FETCHING, STATUS_ERROR, STATUS_READY, STATUS_IDLE } from './constants';

export const fetchUserActivityByUid = createAsyncThunk(
  'getUserActivityByUid',
  async ({ uid, selectedTime }) => await getUserActivityByUid(uid, selectedTime)
);

const userActivitySlice = createSlice({
  name: 'userActivity',
  initialState: {
    status: STATUS_IDLE,
    data: [],
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchUserActivityByUid.pending, (state, action) => {
        state.status = STATUS_FETCHING;
      })
      .addCase(fetchUserActivityByUid.fulfilled, (state, action) => {
        state.status = STATUS_READY;
        state.data = action.payload;
      })
      .addCase(fetchUserActivityByUid.rejected, (state, action) => {
        state.status = STATUS_ERROR;
        state.error = action.error.message;
      });
  },
});

export default userActivitySlice.reducer;
